import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import {makeStyles, Typography} from "@material-ui/core";
import VS from "constants/ValidationShema";
import TextInput from "components/TextInput";
import DoubleButton from "components/popup/components/DoubleButton";
import RfxOfferService from "services/RfxOfferService";
import SingleButton from "components/popup/components/SingleButton";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    disabledEmpty: {
        fontStyle: 'italic'
    }
}));

function ResendOfferInvitationPopup(
    {
        demandId,
        roundId,
        onClose = () => {
        },
        formSubmit
    }) {

    const classes = useStyle();
    const formId = useId();
    const [sent, setSent] = useState(false);
    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = ({emails}, fp) => {
        const emailsTab = getEmailsTab(emails);
        if (emailsTab.length > 0) {
            RfxOfferService.sendIvniteToOffers(roundId, emailsTab).then((resp) => {
                if (resp.success) {
                    setSent(true);
                } else {
                    const errors = resp.errors;
                    const filter = emailsTab.filter((x, i) => errors.hasOwnProperty(`emails[${i}]`));
                    fp.setFieldError("emails", Tr('invalid_emails', {emails: filter.join(",")}))
                }
            }).catch(()=>{});
        } else {
            onClose();
        }
    }

    const getEmailsTab = (emails) => {
        if (!emails) {
            return [];
        }
        return emails.split(';').map(x => x.trim()).filter(x => Boolean(x))

    }


    const emailValidator = VS.email();
    return (
        <Dialog
            title={Tr('resend_offer_invitation_popup_title')}
            open={true}
            maxWidth={'sm'}
        >

            {sent ?
                <>

                    <Typography>{Tr('resend_offer_invitation_success')}</Typography>

                    <div className={classes.actions}>
                        <SingleButton
                            justify='flex-end'
                            label={Tr('close')}
                            onClick={onClose}
                        />
                    </div>

                </>
                :


                <Form
                    initialValues={{
                        emails: "",
                    }}
                    validationSchema={Yup.object().shape({

                        emails: VS.lazy(value => {
                            if (!value)
                                return VS.string();

                            const emailsTab = getEmailsTab(value);

                            const invalidEmails = emailsTab.filter(x => !emailValidator.isValidSync(x));

                            return VS.string().test('valid-emails-comma-separated', Tr('invalid_emails', {emails: invalidEmails.join(",")}), value => invalidEmails.length === 0)


                        })
                    })}
                    onSubmit={onSubmit}
                    id={formId}
                >
                    {(formikProps) => (
                        <GridBlock column>

                            <TextInput
                                id='emails'
                                formikProps={formikProps}
                                label={Tr('resend_offer_invitation_emails')}
                            />

                            <div className={classes.actions}>
                                <DoubleButton
                                    justify='flex-end'
                                    labelFirst={Tr('cancel')}
                                    labelSecond={Tr('confirm')}
                                    onClickFirst={onClose}
                                    onClickSecond={handleSubmit}
                                />
                            </div>
                        </GridBlock>
                    )}
                </Form>
            }
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(ResendOfferInvitationPopup);